import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useHistory, useParams } from 'react-router-dom';
import Content from '../../components/Content/Content';
import FormError from '../../components/FormError/FormError';
import Loader from '../../components/Loader/Loader';
import { getLegacyOrderURL } from '../../endpoints';
import axiosInstance from '../../helpers/axiosInstance';
import { getErrorMessageOrDefault } from '../../helpers/errorMessageHelper/errorMessageHelper';

const LegacyOrder: FC = () => {
	const { id, key } = useParams<{ id: string; key: string }>();
	const { locale, formatMessage } = useIntl();
	const { push } = useHistory();
	const [orderId, setOrderId] = useState<string>();
	const [error, setError] = useState<string>();

	useEffect(() => {
		axiosInstance
			.get<{ id: string }>(getLegacyOrderURL(id, key))
			.then(({ data }) => {
				setOrderId(data.id);
			})
			.catch((e) => setError(formatMessage(getErrorMessageOrDefault(e.response?.data))));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (orderId) push(`/${locale}/payment/order/${orderId}`);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [orderId]);

	return error ? (
		<Content name={error} showBadge={false}>
			<FormError />
		</Content>
	) : (
		<Loader />
	);
};

export default LegacyOrder;
